import { ArchivedBadge } from "@nexxt/app-kit";
import type { LinesheetStatus } from "@nexxt/contracts/catalog";
import { StatusBadge } from "@nexxt/ui";
import { linesheetStatusTone } from "@nexxt/ui/status";
import { m } from "../paraglide/messages.js";
import type { LinesheetSummary } from "./linesheet.queries";

// Badge texts are sentences from the catalog, never enum values (design-system.md §2.2).

export const linesheetStatusLabel: Record<LinesheetStatus, () => string> = {
  draft: m.linesheet_status_draft,
  pending: m.linesheet_status_pending,
  approved: m.linesheet_status_approved,
};

export function LinesheetStatusBadge({ status }: { status: LinesheetStatus | undefined }) {
  return status ? <StatusBadge tone={linesheetStatusTone[status]} label={linesheetStatusLabel[status]()} /> : null;
}

/**
 * Whether the linesheet is archived, and its approval: what the brand and Tomorrow both follow. Prices, Business
 * Central and Joor are Tomorrow's, and Backstage shows them next to these (ADR-166).
 */
export function LinesheetBadges({ ls }: { ls: Pick<LinesheetSummary, "status" | "archivedAt"> }) {
  return (
    <>
      <ArchivedBadge archivedAt={ls.archivedAt} />
      <LinesheetStatusBadge status={ls.status} />
    </>
  );
}
